import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTasks, FaWallet } from 'react-icons/fa';
import { TbHomeDollar } from "react-icons/tb";

const screens = [
    { id: 1, link: '/tasks', name: 'Tasks', icon: <FaTasks size={24} /> },
    { id: 2, link: '/', name: 'Home', icon: <TbHomeDollar size={24} /> },
    { id: 3, link: '/wallet', name: 'Wallet', icon: <FaWallet size={22} /> },
];

const MobileNavigation = () => {
    const location = useLocation();

    return (
        <div className='flex md:hidden w-full text-black justify-evenly text-center bg-[#ffffff5e] backdrop-blur shadow-md fixed bottom-0'>
            {screens.map((screen) => {
                const isActive = location.pathname === screen.link;
                
                return (
                    <Link 
                        key={screen.id} 
                        to={screen.link} 
                        className={`flex flex-col items-center w-full p-2 mt-[1px] hover:bg-zinc-100 ${isActive ? "text-rose-500 font-medium" : "text-zinc-500"}`}
                    >
                        {React.cloneElement(screen.icon, {
                            className: `text-[24px] ${isActive ? "text-rose-500" : "text-zinc-500"}`
                        })}
                        <span className='text-[12px] mt-[1px]'>{screen.name}</span>
                    </Link>
                );
            })}
        </div>
    );
};

export default MobileNavigation;